import { OnInit, AfterViewInit, Component, TemplateRef, ViewChild, ViewContainerRef, ElementRef, Injector, signal } from '@angular/core';
import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, DomPortal, Portal, TemplatePortal } from '@angular/cdk/portal';
import { Subscription } from 'rxjs';
import { BrowserSnifferService } from "../../services/browser-sniffer.service";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BackEventService } from '@tt-lib/services/back-event.service';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '@tt-lib/services/toggle-event.service';

@Component({
  selector: 'tt-header',
  imports: [
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    CommonModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

  @ViewChild('ttHeaderDrawer') ttHeaderDrawer: TemplateRef<unknown>;
  private overlayRef: OverlayRef;
  private subscriptions: Subscription = new Subscription();
  private isAnimating: boolean;
  public isOpen = signal(false);

  constructor(
    private overlay: Overlay,
    private _viewContainerRef: ViewContainerRef,
    private _elementRef: ElementRef<HTMLElement>,
    public browsersniffer: BrowserSnifferService,
    private backEventService: BackEventService,
    private toggleEventService: ToggleEventService
  ) { 
    this.subscriptions.add(
          this.toggleEventService.emitter$.subscribe(
            (toggleEvent: ToggleEventType) => {
              if (toggleEvent.forwardedFor === 'header' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
                if (this.isOpen) {
                      this.close();
                }
              }
          })
        );
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.overlayRef) { this.overlayRef.dispose(); }
  }

  ngAfterViewInit() {
    //  setTimeout(()=> this.toggle(),900)
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  close() {
    this.isOpen.set(false);
    document.getElementsByTagName('body')[0].classList.remove('header-drawer-open');
    const backdropElement: HTMLElement = this.overlayRef.backdropElement!;
    backdropElement.classList.add('tt-backdrop-hidden');
    backdropElement.classList.add('tt-backdrop-none');
  }

  open() {
    if (this.isOpen()) return;
    if (!this.overlayRef) {
      this.overlayRef = this.createOverlay();
      this.subscriptions.add(this.overlayRef.backdropClick().subscribe(_ => this.close()));
    }
    const drawerPortal = new TemplatePortal(this.ttHeaderDrawer, this._viewContainerRef);
    this.overlayRef.attach(drawerPortal);
    this.isOpen.set(true);
    document.getElementsByTagName('body')[0].classList.add('header-drawer-open');
    const backdropElement: HTMLElement = this.overlayRef.backdropElement!;
    backdropElement.classList.remove('tt-backdrop-none')
    backdropElement.classList.remove('tt-backdrop-hidden');

    this.backEventService.registerOpenedWindow({windowName: 'header', isAutoCloseableWindow: false});
  }


  private createOverlay(): OverlayRef {
    const positionStrategy = this.overlay.position()
      .global()
      .top('0')
      .left('0'); // or right('0') if your drawer slides from the right
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'tt-backdrop',
      positionStrategy: positionStrategy
    });
    return this.overlayRef;
  }

  onDrawerTransitionEnd(event: TransitionEvent) {
    if (event.propertyName !== 'transform') return;
    if (!this.isOpen()) {
      this.overlayRef.detach();
    }
  }

}